import script from "./VODReachLimitBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./VODReachLimitBanner.vue?vue&type=script&setup=true&lang=js"

import "./VODReachLimitBanner.vue?vue&type=style&index=0&id=4e293467&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e293467"]])

export default __exports__